import gsap from "gsap/gsap-core";
import { imgsrcs, audiosrcs } from "./assets";

export default class Loader{
    constructor(){
        document.getElementById("loader").classList.add("javascript-loaded");
    }

    load(){
        const images = [];
        imgsrcs.forEach(src=>{
            const img = new Image();
            images.push(img);
            img.onload = () => this.updateProgress();
            img.src = src;
        });

        const audios = [];
        audiosrcs.forEach(src=>{
            const audio = new Audio(src);
            audios.push(audio);
            audio.oncanplaythrough = () => this.updateProgress();
            audio.load();
        });
        this.assetLength = images.length + audios.length;
        this.assetsLoaded = 0;
        this.progress = 0;
    }

    updateProgress(){
        this.assetsLoaded++;
        console.log("assets: " + this.assetsLoaded + "/" + this.assetLength);
        this.progress = this.assetsLoaded / this.assetLength;
        let tl = gsap.timeline();
        tl.to("#loader>div>div",{scaleX:this.progress, duration: .3});

        if(this.progress == 1){
            tl.to("#loader",{autoAlpha:0, duration: .3});
        }
    }

    force(){
        gsap.to("#loader",{autoAlpha:0, duration: .3});
    }
}



